export default "__VITE_ASSET__kZMQTax___"